module.exports = __webpack_public_path__ + "img/signways.f921d297.jpeg";